import React from 'react';
import '../../../common/dropDown/dropDown.scss';
import { injectIntl, FormattedMessage } from 'react-intl';
import InputRange from 'react-input-range';
import { numberWithCommas } from '../../../../utils/consts/index';

const FilterCardRangeInput = (props) => {
  let {
    message,
    originName,
    selectedList,
    destinationName,
    indexFlight,
    list,
    selectedListName,
    selectedValue,
    updateRangeName,
    icon1,
    icon2,
    icon3,
    headerIcon,
    applyStyle,
    resetRangeName,
    languageName,
  } = props;
  return (
    <div className="card bg-primary text-white  border-top-0 border-right-0 border-left-0 border-bottom border-bottom-1  border-light rounded-0 my-3 ">
      <div
        className={`font-weight-bold bg-primary text-white border-0 card-header font-small  px-0 d-flex justify-content-between ${
          languageName === 'fa' ? 'text-right' : 'text-left'
        }`}
      >
        <div className="d-flex flex-start align-items-center">
          {applyStyle ? (
            <div style={{ transform: 'rotateY(180deg)' }}>{headerIcon}</div>
          ) : (
            headerIcon
          )}
          <span className="px-2">
            <FormattedMessage id={message} defaultMessage={message} />
          </span>
        </div>
        <div className="d-flex flex-grow-1 align-items-center">
          &nbsp;
          <span className={`text-white font-smaller`}>
            {destinationName ? `(${originName}` : originName}
            {destinationName && (
              <React.Fragment>
                <span className="font-smaller text-white">
                  {` - ${destinationName} )`}
                </span>
              </React.Fragment>
            )}
          </span>
        </div>
        {selectedList && selectedList[indexFlight] ? (
          Object.entries(selectedList[indexFlight]).length &&
          (selectedList[indexFlight].min != list[indexFlight].min ||
            selectedList[indexFlight].max != list[indexFlight].max) ? (
            <div className="d-flex flex-end align-items-center">
              <span
                className="linkableDiv px-1  text-gold font-smaller cursor-pointer"
                onClick={() => {
                  props.resetInputRange(resetRangeName, indexFlight);
                  props.filterFunction();
                }}
              >
                <FormattedMessage
                  id="booking.clearfilter"
                  defaultMessage="booking.clearfilter"
                />
              </span>
            </div>
          ) : selectedList ? (
            selectedList.min != list.min || selectedList.max != list.max ? (
              <div className="d-flex flex-end align-items-center">
                <span
                  className="linkableDiv px-1  text-gold font-smaller cursor-pointer"
                  onClick={() => {
                    props.resetInputRange(resetRangeName, indexFlight);
                    props.filterFunction();
                  }}
                >
                  <FormattedMessage
                    id="booking.clearfilter"
                    defaultMessage="booking.clearfilter"
                  />
                </span>
              </div>
            ) : (
              <></>
            )
          ) : (
            <></>
          )
        ) : selectedList &&
          Object.entries(selectedList).length &&
          (selectedList.min != list.min || selectedList.max != list.max) ? (
          <div className="d-flex flex-end align-items-center">
            <span
              className="linkableDiv px-1  text-gold font-smaller cursor-pointer "
              onClick={() => {
                props.resetInputRange(resetRangeName, indexFlight);
                props.filterFunction();
              }}
            >
              <FormattedMessage
                id="booking.clearfilter"
                defaultMessage="booking.clearfilter"
              />
            </span>
          </div>
        ) : (
          <></>
        )}
      </div>
      <div className="card-body py-3">
        <div className="d-flex w-100 justify-content-between px-4 pb-3">
          {icon1 || <></>}
          {icon2 || <></>}
          {icon3 || <></>}
        </div>
        <div className="d-flex col-12 flex-column">
          <div className="col-12 py-2" style={{ direction: 'ltr' }}>
            {selectedListName !== 'priceRangeSelected' ? (
              <InputRange
                formatLabel={(value) => `${value}:00`}
                disabled={list?.[indexFlight]?.max === list?.[indexFlight]?.min}
                allowSameValues={true}
                maxValue={
                  list?.[indexFlight]?.max > list?.[indexFlight]?.min
                    ? list?.[indexFlight]?.max
                    : list?.[indexFlight]?.max + 1
                }
                minValue={list?.[indexFlight]?.min || 0}
                step={1}
                value={selectedValue}
                onChange={(range) => {
                  props.updateRange(range, indexFlight, updateRangeName);
                }}
                onChangeComplete={(depart) =>
                  props.filterFlight(depart, selectedListName, indexFlight)
                }
              />
            ) : (
              <InputRange
                formatLabel={(value) => numberWithCommas(value)}
                allowSameValues={true}
                disabled={list?.max === list?.min}
                maxValue={list?.max > list?.min ? list?.max : list?.max + 100}
                step={1}
                minValue={list?.min}
                value={selectedValue}
                onChange={(range) =>
                  props.updateRange(range, -1, updateRangeName)
                }
                onChangeComplete={(range) =>
                  props.filterFlight(range, selectedListName, -1)
                }
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(FilterCardRangeInput);
